import { render } from "./schoolSafeVideo.vue?vue&type=template&id=193d7916&scoped=true"
import script from "./schoolSafeVideo.vue?vue&type=script&lang=js"
export * from "./schoolSafeVideo.vue?vue&type=script&lang=js"

import "./schoolSafeVideo.vue?vue&type=style&index=0&id=193d7916&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193d7916"]])

export default __exports__